var _path, _path2, _ellipse, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 161,
    viewBox: "0 0 141 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5975 135.126C75.4525 144.071 50.0966 129.361 35.9636 102.271C21.8305 75.1803 24.2722 45.9683 41.4172 37.0237C58.5622 28.0791 83.9181 42.7891 98.0511 69.8793C112.184 96.9696 109.742 126.182 92.5975 135.126Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6103 96.5718C35.4773 69.4816 37.9189 40.2696 55.0639 31.325L41.417 37.0223C24.272 45.9669 21.8304 75.1788 35.9634 102.269C50.0965 129.359 75.4523 144.069 92.5973 135.125L102.69 130.911C103.908 130.521 105.095 130.027 106.244 129.427L102.69 130.911C85.7493 136.344 62.7957 121.846 49.6103 96.5718Z",
    fill: "url(#paint0_linear_1339_22740)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.6557,
    cy: 80.3757,
    rx: 55.3252,
    ry: 35.0145,
    transform: "rotate(62.4488 80.6557 80.3757)",
    fill: "url(#paint1_linear_1339_22740)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.701 64.1823C97.5675 37.0921 72.2116 22.3821 55.0666 31.3267L44.9735 35.5404C43.7559 35.9308 42.5693 36.4243 41.4197 37.024L44.9735 35.5404C61.9147 30.1078 84.8683 44.6059 98.0536 69.8796C112.187 96.9699 109.745 126.182 92.6 135.126L106.247 129.429C123.392 120.485 125.834 91.2726 111.701 64.1823Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0666 31.3267C72.2116 22.3821 97.5675 37.0921 111.701 64.1823C125.834 91.2726 123.392 120.485 106.247 129.429L92.6 135.126C109.745 126.182 112.187 96.9699 98.0536 69.8796C84.8683 44.6059 61.9147 30.1078 44.9735 35.5404L44.9744 35.54M41.4197 37.024L44.9735 35.5404C43.7559 35.9308 42.5693 36.4243 41.4197 37.024Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.347 118.655C87.6776 125.752 67.437 114.033 56.1383 92.4784C44.8397 70.9242 46.7616 47.6976 60.431 40.6003C74.1004 33.5029 94.3411 45.2225 105.64 66.7767C116.938 88.3308 115.016 111.557 101.347 118.655Z",
    fill: "#7551FF",
    fillOpacity: 0.77
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_22740",
    x1: 30.3621,
    y1: 48.2067,
    x2: 55.1567,
    y2: 130.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1339_22740",
    x1: 25.3306,
    y1: 80.3757,
    x2: 135.981,
    y2: 80.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BA9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin4);
export default __webpack_public_path__ + "static/media/Coin4.76ad5a20b54eb80c67608e296defae66.svg";
export { ForwardRef as ReactComponent };